import React from 'react';
import { Button } from 'primereact/button';
import {
    InputSwitch,
    InputSwitchChangeEvent,
} from 'primereact/inputswitch';
import { useTranslation } from 'react-i18next';

// @ts-ignore
import { ReactComponent as SelectIcon } from '../../../assets/images/select_button.svg';
// @ts-ignore
import { ReactComponent as SaveIcon } from '../../../assets/images/save-icon.svg';
// @ts-ignore
import { ReactComponent as CancelIcon } from '../../../assets/images/cancel-white.svg';
// @ts-ignore
import { ReactComponent as AddProductsIcon } from '../../../assets/images/add-circle-white.svg';
// @ts-ignore
import { ReactComponent as SettingsIcon } from '../../../assets/images/setting2-icon.svg';

interface PlanogramHeaderActionsProps {
    isSelectionMode: boolean;
    isLoading?: boolean;
    showOnlyEmptyCells?: boolean;
    onSelectModeToggle?: () => void;
    onCancelSelection?: () => void;
    onPlanogramSave?: () => void;
    onApplyToDevice?: () => void;
    onToggleShowOnlyEmptyCells?: (
        event: InputSwitchChangeEvent,
    ) => void;
    onAssignProduct?: () => void;
    onSchemeSettingsClick?: () => void;
    showEmptyCellsToggle?: boolean;
    isReadOnlyMode?: boolean;
    isEmptyState?: boolean;
    disableApplyToDevice?: boolean;
    onPlanogramCancel?: () => void;
}

const PlanogramHeaderActions = ({
    isSelectionMode,
    isLoading = false,
    showOnlyEmptyCells = false,
    onSelectModeToggle,
    onCancelSelection,
    onPlanogramCancel,
    onPlanogramSave,
    onToggleShowOnlyEmptyCells,
    onAssignProduct,
    onSchemeSettingsClick,
    showEmptyCellsToggle = false,
    isReadOnlyMode = false,
    isEmptyState = false,
}: PlanogramHeaderActionsProps) => {
    const { t } = useTranslation();

    const headerActionsDisabled =
        isReadOnlyMode || isSelectionMode;

    if (isEmptyState) {
        return (
            <div className="flex gap-2 align-items-center">
                <Button
                    className="small"
                    onClick={onAssignProduct}
                    disabled={isReadOnlyMode}
                >
                    <AddProductsIcon />
                    <span className="p-button-label pl-2">
                        {t(
                            'planogram.addProducts',
                            'Add Products',
                        )}
                    </span>
                </Button>

                <Button
                    className="small planogram-header-settings-button"
                    onClick={onSchemeSettingsClick}
                    disabled={isReadOnlyMode}
                >
                    <SettingsIcon />
                </Button>
            </div>
        );
    }

    return (
        <div className="flex gap-2 align-items-center">
            {showEmptyCellsToggle && (
                <>
                    <InputSwitch
                        checked={showOnlyEmptyCells}
                        onChange={onToggleShowOnlyEmptyCells}
                        disabled={headerActionsDisabled}
                    />
                    <span className="toggle-text">
                        {t('planogram.showOnlyEmptyCells')}
                    </span>
                </>
            )}

            <Button
                className="small"
                onClick={onSelectModeToggle}
                disabled={headerActionsDisabled}
            >
                <SelectIcon />
                <span className="p-button-label pl-2">
                    {t('planogram.select', 'Select')}
                </span>
            </Button>

            {!isReadOnlyMode && (
                <>
                    <Button
                        className="small p-button-danger"
                        onClick={onPlanogramCancel}
                    >
                        <CancelIcon />
                        <span className="p-button-label pl-2">
                            {t('common.cancel', 'Cancel')}
                        </span>
                    </Button>

                    <Button
                        className="small planogram-save-button"
                        onClick={onPlanogramSave}
                        loading={isLoading}
                        disabled={isSelectionMode}
                    >
                        <SaveIcon />
                        <span className="p-button-label pl-2">
                            {t(
                                'planogram.saveButton',
                                'Save',
                            )}
                        </span>
                    </Button>
                </>
            )}
        </div>
    );
};

export default PlanogramHeaderActions;